import {
  type CountryCode,
  isSupportedCountry,
  parsePhoneNumberFromString,
} from 'libphonenumber-js/max'

/**
 * Narrows a country code from the API or form state to a libphonenumber-js `CountryCode`.
 * Codes are matched case-insensitively, as the phone schemas already do; unsupported or empty
 * values become `null`.
 */
export const toCountryCode = (value: null | string | undefined): CountryCode | null => {
  if (!value) return null
  const country = value.toUpperCase()
  return isSupportedCountry(country) ? country : null
}

export const formatPhoneToInternational = (
  phone: string | undefined,
  countryCode: string,
): string | undefined => {
  if (!phone) return undefined

  try {
    const parsed = parsePhoneNumberFromString(phone, toCountryCode(countryCode) ?? undefined)
    return parsed?.formatInternational() ?? phone
  } catch {
    return phone
  }
}
